import { render } from "./AlertsDialog.vue?vue&type=template&id=352ec9c6&scoped=true"
import script from "./AlertsDialog.vue?vue&type=script&lang=js"
export * from "./AlertsDialog.vue?vue&type=script&lang=js"

import "./AlertsDialog.vue?vue&type=style&index=0&id=352ec9c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352ec9c6"]])

export default __exports__